import { useCallback, useEffect, useLayoutEffect, useRef } from 'react'

// useLayoutEffect warns during server rendering; the ref update only matters in the browser.
const useIsomorphicLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect

// Returns a function with one identity for the component's lifetime that always runs the latest
// `callback`. For handlers passed through context or memoized children, where a new identity per
// render would re-render every consumer. Not for calling during render: the latest callback is
// installed after commit.
export default function useStableCallback(callback) {
  const callbackRef = useRef(callback)

  useIsomorphicLayoutEffect(() => {
    callbackRef.current = callback
  })

  return useCallback((...args) => callbackRef.current(...args), [])
}
